module.exports = __webpack_public_path__ + "img/top.fe2977b2.png";